import {getData} from "../api/get-data";

export const getItems = ({filter, sort = `pa`, activePage = 1, resolveHandler}) => {
  getData({
    [`get_items`]: {
      [`filter`]: filter,
      [`order_by`]: sort,
      [`page_num`]: String(activePage),
    }
  })
  .then((response) => {
    resolveHandler(response);
  });
};
